import { on } from "delegated-events";
import { slideUp, slideDown } from "@common/slide";
import Swiper from "swiper";
import { A11y, Autoplay, EffectFade, Pagination } from "swiper/modules";
import "@styles/components/slider.css";
import scrollTo from "@common/scroll-to";

const slider = document.querySelector(".featured-stories-slider");

if (slider) {
  const container = slider.querySelector(".swiper");
  const numSlides = slider.querySelectorAll(".swiper-slide").length;

  if (numSlides > 1) {
    const opts = {
      modules: [A11y, Autoplay, EffectFade, Pagination],
      autoplay: {
        delay: 6000,
        pauseOnMouseEnter: true,
      },
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      speed: 1000,
      allowTouchMove: false,
      simulateTouch: false,
      pagination: {
        el: slider.querySelector(".slider-pagination"),
        clickable: true,
      },
    };

    const swiper = new Swiper(container, opts);

    on("tablist:tabshow", "html", () => {
      swiper.update();
    });
  }
}

on("click", ".accordion-toggle-all", (e) => {
  const holder = e.target.closest(".element-contentaccordion");
  const items = holder.querySelectorAll(".accordion-item");
  const type = e.target.dataset.type;

  if (type === "open") {
    items.forEach(async (item) => {
      const target = document.getElementById(item.getAttribute("aria-controls"));
      item.setAttribute("aria-expanded", "true");
      item.parentNode.classList.add("is-active");

      await slideDown(target);
    });
  }

  if (type === "close") {
    items.forEach(async (item) => {
      const target = document.getElementById(item.getAttribute("aria-controls"));
      item.setAttribute("aria-expanded", "false");
      item.parentNode.classList.remove("is-active");

      await slideUp(target);
    });
  }
});

const els = document.querySelectorAll(".element-contentaccordion");

const observer = new MutationObserver((mutationList) => {
  for (const mutation of mutationList) {
    if (mutation.type === "attributes" && mutation.attributeName === "aria-expanded") {
      els.forEach((el) => {
        const total = el.querySelectorAll(".accordion-item").length;
        const opened = el.querySelectorAll('.accordion-item[aria-expanded="true"]').length;
        const toggle = el.querySelector(".accordion-toggle-all");

        if (opened === total) {
          toggle.textContent = "Hide All";
          toggle.setAttribute("data-type", "close");
        } else {
          toggle.textContent = "View All";
          toggle.setAttribute("data-type", "open");
        }
      });
    }
  }
});

els.forEach((el) => {
  el.querySelectorAll(".accordion-item").forEach((item) => {
    observer.observe(item, { attributes: true });
  });
});

const handleUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.has("tab")) {
    setTimeout(() => {
      scrollTo(document.getElementById("tabs-panel"), 32);
    }, 250);
  }
};

const handleCta = () => {
  const cta = document.querySelector(".page-header-actions a[href*=how-to-get-started]");
  const tab = document.getElementById("tab-get-started");

  if (cta && tab) {
    cta.addEventListener("click", (e) => {
      e.preventDefault();

      tab.click();
      scrollTo(document.getElementById("tabs-panel"), 32);
    });
  }
};

handleUrl();
handleCta();
